/** @file ikDrag: the IK tool's gesture, the dragged end joint moved in the view plane (no chain solve). */
import { screenDeltaToWorld } from '@zilo/pose3d-render-core/camera/screenDeltaToWorld';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';
import type { WorldDrag } from './viewportDrag';

/**
 * The world offset that follows the pointer from `from` to `to` (target pixels) in the view plane; the viewport keys
 * it as the end node's `pos` (the document route: a full IK solve is out of scope for W5, plan Task T-503 step 5).
 */
export function ikDrag(view: View, from: [number, number], to: [number, number]): WorldDrag {
  return { kind: 'move', delta: screenDeltaToWorld(to[0] - from[0], to[1] - from[1], view) };
}
